module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAGmb2P///yH5BAAHAP8ALAAAAAAMAAwAAAIThI+pGu1rHpSsTbtoDRA43YVIAQA7"